import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectErrorMessage, selectEstimationTarget } from '../../../selectors/filters';
import { ErrorMessageBanner } from '../../../components/ErrorMessage';
import { EEstimationTargets } from '@cian/valuation-main-filters-widget';
import { useAppDispatch } from '../../../hooks';
import { deleteErrorMessage } from '../../../slices';

export const ErrorMessageContainer: React.FC = () => {
  const dispatch = useAppDispatch();

  const errorMessage = useSelector(selectErrorMessage);
  const estimationTarget: EEstimationTargets = useSelector(selectEstimationTarget);

  React.useEffect(() => {
    // При смене типа недвижимости убираем сообщение об ошибке
    dispatch(deleteErrorMessage());
  }, [dispatch, estimationTarget]);

  if (!errorMessage) {
    return null;
  }

  return <ErrorMessageBanner title={errorMessage} />;
};
